import { render, staticRenderFns } from "./ProductionEstablishmentSelector.vue?vue&type=template&id=8becc41c"
import script from "./ProductionEstablishmentSelector.vue?vue&type=script&lang=js"
export * from "./ProductionEstablishmentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports